import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Step = makeShortcode("Step");
const ProductScreenshot = makeShortcode("ProductScreenshot");
const OSButton = makeShortcode("OSButton");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Step checkpoint title="Verify traces and generations" subtitle="Confirm LLM events are being sent to PostHog" mdxType="Step">
      <p>{`Let's make sure LLM events are being captured and sent to PostHog. Under `}<strong parentName="p">{`LLM analytics`}</strong>{`, you should see rows of data appear in the `}<strong parentName="p">{`Traces`}</strong>{` and `}<strong parentName="p">{`Generations`}</strong>{` tabs.`}</p>
      <br />
      <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/SCR_20250807_syne_ecd0801880.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/SCR_20250807_syjm_5baab36590.png" alt="LLM generations in PostHog" classes="rounded" className="mt-10" padding={false} mdxType="ProductScreenshot" />
      <OSButton variant="secondary" asLink className="my-2" size="sm" to="https://app.posthog.com/llm-analytics/generations" external mdxType="OSButton">
  Check for LLM events in PostHog
      </OSButton>
    </Step>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      